import { init } from './index';
init();
